import { RequestContactPersonSectionProps } from './RequestContactPersonSection.types';

export const getFullName = ({
    firstName,
    lastName,
}: Pick<RequestContactPersonSectionProps['contact'], 'firstName' | 'lastName'>) => {
    return `${firstName || ''} ${lastName || ''}`.trim();
};
